module.exports = __webpack_public_path__ + "img/IMG_20200712_204942.a7dd0daf.jpg";